module.exports = __webpack_public_path__ + "img/book_richang.0be17541.png";